export const SET_DATA_ROWS_ANULACION =
  'anulacion/SET_DATA_ROWS_CAMBIO_ADICIONAL';
export const FETCH_DATA_ANULACION = 'anulacion/FETCH_DATA_ANULACION';
export const GET_DATA_ROWS_ANULACION =
  'anulacion/GET_DATA_ROWS_CAMBIO_ADICIONAL';
